import { useTranslation } from 'react-i18next'
import RozmowaNewOsobaSection from '../../add/components/RozmowaNewOsobaSection'
import RozmowaPlacowkaSection from '../../add/components/RozmowaPlacowkaSection'

const getRelationId = relation => {
	if (!relation) return ''
	if (typeof relation === 'object') return relation?._id || relation?.id || ''
	return relation
}

const getRelationName = relation => {
	if (!relation || typeof relation !== 'object') return ''
	return relation?.imie_i_nazwisko || relation?.nazwa || relation?.alternative_name || relation?.name || relation?.email || ''
}

export default function RozmowaForm({
	mode = 'add',
	form,
	onCancel,
	onChange,
	onClearPlacowka,
	onSelectOsoba,
	onSelectPlacowka,
	onSubmit,
	loadingOsoby,
	newOsoba,
	onNewOsobaChange,
	onOsobaModeChange,
	osobaMode = 'existing',
	osoby,
	osobyError,
	selectedPlacowka,
	submitting,
}) {
	const { t } = useTranslation()
	const isEdit = mode === 'edit'
	const canAddNewOsoba = !isEdit && typeof onOsobaModeChange === 'function'
	const addingNewOsoba = canAddNewOsoba && osobaMode === 'new'

	return (
		<form className="space-y-6" onSubmit={onSubmit}>
			<RozmowaPlacowkaSection
				selectedPlacowka={selectedPlacowka}
				onSelectPlacowka={onSelectPlacowka}
				onClearPlacowka={onClearPlacowka}
				t={t}
			/>

			<div className={`grid grid-cols-1 gap-4 ${isEdit ? 'md:grid-cols-2' : ''}`}>
				<div className="flex flex-col gap-2">
					<span className="text-sm font-medium text-gray-700">{t('conversations.add.fields.person')} *</span>
					{canAddNewOsoba && (
						<div className="flex flex-col gap-2 sm:flex-row sm:gap-4">
							<label className="inline-flex items-center gap-2 text-sm text-gray-700">
								<input
									type="radio"
									name="osobaMode"
									value="existing"
									checked={osobaMode === 'existing'}
									onChange={() => onOsobaModeChange('existing')}
									className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
								/>
								{t('conversations.add.personMode.existing')}
							</label>
							<label className="inline-flex items-center gap-2 text-sm text-gray-700">
								<input
									type="radio"
									name="osobaMode"
									value="new"
									checked={osobaMode === 'new'}
									onChange={() => onOsobaModeChange('new')}
									className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
								/>
								{t('conversations.add.personMode.new')}
							</label>
						</div>
					)}
					<label className="flex flex-col gap-1">
						<select
							value={form.id_osoba}
							onChange={event => onSelectOsoba(event.target.value)}
							disabled={!selectedPlacowka || loadingOsoby || addingNewOsoba}
							className="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
							required={!addingNewOsoba}
						>
							<option value="">
								{selectedPlacowka
									? t('conversations.add.placeholders.person')
									: t('conversations.add.placeholders.personBeforeFacility')}
							</option>
							{osoby.map(osoba => {
								const osobaId = getRelationId(osoba)
								if (!osobaId) return null

								return (
									<option key={osobaId} value={osobaId}>
										{getRelationName(osoba) || osobaId}
									</option>
								)
							})}
						</select>
						{loadingOsoby && <span className="text-sm text-gray-500">{t('conversations.add.messages.personsLoading')}</span>}
						{osobyError && <span className="text-sm text-red-600">{osobyError}</span>}
						{selectedPlacowka && !loadingOsoby && !osobyError && osoby.length === 0 && (
							<span className="text-sm text-gray-500">{t('conversations.add.messages.personsEmpty')}</span>
						)}
					</label>
				</div>

				<label className="flex flex-col gap-1">
					<span className="text-sm font-medium text-gray-700">{t('conversations.add.fields.conversationDate')} *</span>
					<input
						type="datetime-local"
						value={form.dig_rozmowy}
						onChange={event => onChange('dig_rozmowy', event.target.value)}
						className="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
						required
					/>
				</label>
			</div>

			{canAddNewOsoba && (
				<RozmowaNewOsobaSection
					active={addingNewOsoba}
					disabled={!selectedPlacowka}
					newOsoba={newOsoba}
					onChange={onNewOsobaChange}
					placowkaName={selectedPlacowka?.nazwa || ''}
					t={t}
				/>
			)}

			<div className="flex justify-end gap-3 border-t border-gray-200 pt-4">
				<button
					type="submit"
					disabled={submitting}
					className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50"
				>
					{submitting
						? isEdit
							? t('conversations.edit.submitting')
							: t('conversations.add.submitting')
						: isEdit
							? t('conversations.edit.submit')
							: t('conversations.add.submit')}
				</button>
				<button
					type="button"
					onClick={onCancel}
					className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50"
				>
					{t('conversations.add.cancel')}
				</button>
			</div>
		</form>
	)
}
